import { FC, useEffect, useMemo, useState } from "react"
import { useKeyPress } from "ahooks"

type TRadiusChangerProps = {
  defaultValue?: number
  storeKey: string
  trigerKeyAgg: string
  trigerKeyDec: string
  max?: number
  min?: number
  step?: number
}
type TRadiusChanger = {
  value: number
}

const useRadiusChanger = (
  storeKey: string,
  trigerKeyAgg: string | string[],
  trigerKeyDec: string | string[],
  defaultValue = 40,
  max = 100,
  min = 0,
  step = 5
) => {
  const [value, setValue] = useState<number>(defaultValue)
  useKeyPress(trigerKeyAgg, (e) => {
    setValue(Math.min(max, value + step))
  })
  useKeyPress(trigerKeyDec, (e) => {
    setValue(Math.max(min, value - step))
  })
  useMemo(() => {
    let initial: any = localStorage.getItem(storeKey)
    if (initial) {
      initial = parseInt(initial)
      if (!isNaN(initial)) {
        setValue(initial)
      }
    }
  }, [])
  useEffect(() => {
    localStorage.setItem(storeKey, value + "")
  }, [value])
  return { value }
}

export default useRadiusChanger
